export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M17 8.56h1c1.1 0 2 .88 2 1.96v9.8c0 1.07-.9 1.95-2 1.95H6c-1.1 0-2-.88-2-1.96v-9.8c0-1.07.9-1.95 2-1.95h1V6.6c0-2.7 2.24-4.9 5-4.9s5 2.2 5 4.9v1.96zM8.9 6.6v1.96h6.2V6.6A3.07 3.07 0 0012 3.56 3.07 3.07 0 008.9 6.6zM12 17.37c1.1 0 2-.87 2-1.96 0-1.08-.9-1.95-2-1.95s-2 .87-2 1.95c0 1.09.9 1.96 2 1.96z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  }
};